import { m } from "framer-motion";

import EmailPill from "./EmailPill";
import SVGPattern from "./SVGPattern";

function StartHiringCTA() {
	return (
		<section className="px-2 sm:px-4">
			<m.div
				className="relative bg-blue-800 rounded-2xl overflow-hidden py-16 sm:py-20"
				initial={{ opacity: 0, y: 24 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true, margin: "-64px" }}
				transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
			>
				<div className="absolute inset-0 opacity-[0.06]">
					<SVGPattern
						style={{
							width: "100%",
							height: "100%",
							transform: "scale(1.5)",
						}}
					/>
				</div>

				<div className="relative z-10 max-w-2xl mx-auto px-4 text-center">
					<h2 className="font-plus-jakarta text-[clamp(1.75rem,4.5vw,3rem)] font-bold text-white tracking-tight leading-tight mb-5">
						Ready to find your next hire?
					</h2>
					<p className="font-inter text-lg text-white/70 leading-relaxed mb-10 max-w-lg mx-auto">
						Send us the job description. We'll publish and promote it to thousands of candidates.
					</p>
					<EmailPill />
				</div>
			</m.div>
		</section>
	);
}

export default StartHiringCTA;
